import { HttpStatusCode } from 'axios';

export function isUnauthorized(value: number | undefined) {
  return (
    value === HttpStatusCode.Forbidden || value === HttpStatusCode.Unauthorized
  );
}
